import React, { Component } from "react";
import dialogTheme from "css/themes/dialogs/formModal.css";
import Dialog from "react-toolbox/lib/dialog";

export default class DojoModal extends Component {
  render() {
    const { isOpen, hideModal, customHeader, children, title, className } = this.props;

    return (
      <Dialog
        theme={dialogTheme}
        className={dialogTheme[className]}
        active={!!isOpen}
        onEscKeyDown={hideModal}
        onOverlayClick={hideModal}
        title={title}
      >
        {customHeader ? <customHeader /> : null}
        {children}
      </Dialog>
    );
  }
}
